import React, {Component} from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { BackIcon } from '../../Svg/Index.js'
import { SET_TYPE, SET_PROFILE_OPEN } from '../../Actions/Sidebar'
import { REFUSE_REQUEST, ACCEPT_REQUEST, REMOVE_FRIEND, REVOKE_REQUEST, GET_PROFILE_BY_ID } from '../../Actions/User'

class FriendsOverviewTheirs extends Component {

    state = {
        dialogActive: false,
        remove_friend_id: null,
        friends_friends: []
    }

    changeType = (type) => {
        this.props.actions.SET_TYPE(type)
    }

    handleDelete(id) {
        this.props.actions.REFUSE_REQUEST(id).then(res => {
        })
    }

    handleAccept(id) {
        this.props.actions.ACCEPT_REQUEST(id).then(res => {
        })
    }

    handleRevokeRequest = (id) => {
        this.props.actions.REVOKE_REQUEST(id)
    }

    handleFriendRemove = ()=> {
        this.props.actions.REMOVE_FRIEND(this.state.remove_friend_id).then(res => {
            this.setState({dialogActive: false})
        })
    }

    showProfile = (e, userId) => {
        if(e.target.classList.contains('c-btn')) return;
        this.props.actions.SET_PROFILE_OPEN(userId);
        this.props.actions.SET_TYPE('')
    }

    componentDidMount() {
        const { profile_theirs_open } = this.props.sidebar
        this.props.actions.SET_PROFILE_OPEN(false);

        this.props.actions.GET_PROFILE_BY_ID(profile_theirs_open).then(user => {

            this.setState({
                friends_friends: user.friends
            })
        })
    }

    render() {
        const { dialogActive, friends_friends } = this.state

        return (
            <div className="c-sidebar-overlay c-sidebar-overlay--friends-theirs">
                <div className="c-sidebar-overlay__inner">
                    <button className="c-btn c-btn--back" onClick={ () => this.changeType('') }>
                        <BackIcon />
                    </button>

                    {
                        friends_friends.length > 0 && (
                            <>
                                <h2 className="c-sidebar-overlay__title">Vrienden</h2>
                                <ul className="c-list">
                                    {
                                        friends_friends.map((item, i) => 
                                            <li className="c-list__item" onClick={(e) => this.showProfile(e, item._id)}  key={`user-${item._id}}`}>
                                                <div className="c-list-user">
                                                    <div className="c-list-avatar" style={{backgroundImage: `url(${item.avatar.user_avatar})`}}>
                                                    </div>
                                                    <span className="c-list-user__name">{item.display_name}</span>
                                                
                                                </div>
                                            </li>
                                        )
                                    }        
                                </ul>
                            </>
                        )
                    }

                </div>

                {
                    dialogActive && (
                        <div className="c-dialog">
                            <div className="c-dialog__inner">
                                <h2>Weet je het zeker?</h2>
                                <button className="c-btn c-btn--primary" onClick={this.handleFriendRemove}>Ja, verwijder</button>
                                <button className="c-btn c-btn--primary" onClick={ () => this.setState({dialogActive: false}) }>Nee, annuleren</button>
                            </div>
                        </div>
                    )
                }

            </div>
        )
    }
}
const mapStateToProps = state => {
    return {
        user: state.user.user,
        sidebar: state.sidebar,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        actions: bindActionCreators({SET_TYPE, REFUSE_REQUEST, ACCEPT_REQUEST, REMOVE_FRIEND, REVOKE_REQUEST, SET_PROFILE_OPEN, GET_PROFILE_BY_ID}, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FriendsOverviewTheirs)